import { createStyles, makeStyles, Theme } from "@material-ui/core";
import React, { useEffect, useRef } from "react";

export const useStylesNewProposalsModal = makeStyles((theme: Theme) => createStyles({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
    transition: 'opacity 0.3s ease',
    opacity: 0,
    visibility: 'hidden',
  },
  open: {
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.3s ease-in-out',
  },
  closed: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 0.3s ease-in-out',
  },
  container: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  },
  paper: {
    width: '800px',
    maxHeight: 'calc(100vh - 80px)',
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '8px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
    position: "relative",
    boxShadow: theme.shadows[5],
    _focus: {
      outline: 'none',
      border: 'none',
    },
    [theme.breakpoints.down(1024)]: {
      width: "600px",
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: "calc(100vw - 16px)",
      width: '100%',
      maxHeight: 'calc(100vh - 16px)',
    },
  },
}))

interface ModalCustomProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalCustom: React.FC<ModalCustomProps> = ({ isOpen, onClose, children }) => {
  const classes = useStylesNewProposalsModal();
  const modalRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <div className={`${classes.modal} ${isOpen ? classes.open : classes.closed}`}>
      <div className={classes.container}>
        <div className={classes.paper} ref={modalRef}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ModalCustom